import { computerMcqChapters, computerTop100Mcqs } from "~/features/computer/data/mcq-registry";
import type { ComputerMcq, ComputerMcqChapter, ComputerMcqPriority, ComputerMcqUnit } from "~/features/computer/types/computer";

export type McqClusterMeta = {
  chapter: number;
  slug: string;
  unit: ComputerMcqUnit;
  shortTitle: string;
  title: string;
  description: string;
  priority: ComputerMcqPriority;
  clusterTo: string;
  chapterTo: string;
  mcqTo: string;
  notesTo: string;
  exerciseTo: string;
};

function toClusterMeta(chapter: ComputerMcqChapter): McqClusterMeta {
  return {
    chapter: chapter.chapter,
    slug: chapter.slug,
    unit: chapter.unit,
    shortTitle: chapter.shortTitle,
    title: chapter.title,
    description: chapter.description,
    priority: chapter.priority,
    clusterTo: chapter.routes.clusterTo,
    chapterTo: chapter.routes.chapterTo,
    mcqTo: chapter.routes.mcqTo,
    notesTo: chapter.routes.notesTo,
    exerciseTo: chapter.routes.exerciseTo,
  };
}

export const mcqChapterClusters = computerMcqChapters.map(toClusterMeta);
export const mcqChapterClusterBySlug = Object.fromEntries(
  computerMcqChapters.map((chapter) => [chapter.slug, toClusterMeta(chapter)]),
) as Record<string, McqClusterMeta>;
export const mcqChapterClusterByUnit = Object.fromEntries(
  computerMcqChapters.map((chapter) => [chapter.unit, toClusterMeta(chapter)]),
) as Record<ComputerMcqUnit, McqClusterMeta>;

export const top100Mcqs: ComputerMcq[] = computerTop100Mcqs;
